import qs from 'qs'

export default {
    namespaced: true,
    state: {
        addresses: {},
        edit_address_popup_show: false,
    },
    mutations: {
        set_addresses(state, addresses) {
            state.addresses = addresses;
        },
        set_edit_address_popup_show(state, show) {
            state.edit_address_popup_show = show;
        }
    },
    actions: {
        async get_user_addresses({commit, state}) {
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'get_addresses',
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            }).then((res) => {
                commit('set_addresses', res.data.data.addresses);

            }).catch((e) => {
                // console.log('error')
                // console.log(e)
            })
        },
        async remove_shipping_address({commit, state}, row_num) {
            let parameters = {
                action: 'remove_shipping_address',
                row_num: row_num,
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true})
        },
        async clear_default_shipping_address({commit, state}) {
            let parameters = {
                action: 'clear_default_shipping_address',
            }
            await this.axios.post(window.global.ajax, {params: parameters}, {withCredentials: true}).then((res) => {
                // commit('set_addresses', res.data.data.addresses);
            })
        },
        async set_address({commit, state}, data) {
            let parameters = {
                action: 'set_address',
                names_data: data['names_data'],
                shipping_data: data['shipping_data'],
                default: data['default'],
                row_num: data['row_num'],
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                // commit('set_addresses', res.data.data.addresses);
            })
        },
        async add_another_address({commit, state}, data) {
            let parameters = {
                action: 'add_another_address',
                names_data: data['names_data'],
                shipping_data: data['shipping_data'],
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                // commit('set_addresses', res.data.data.addresses);
            })
        },
    },
    getters: {
        get_addresses: (state) =>
            state.addresses

        ,
        edit_address_popup_visibility: (state) => state.edit_address_popup_show,
    }
};